import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectMobileBannerCookieState(state: IApplicationState): boolean {
  return state.cookies.mobileBanner;
}
